<script>
/**
 * This is the "Status" widget in project-data route.
 */
import VProjectActionCategoryForm from "@/components/Forms/VProjectActionCategoryForm.vue";
import VControl from "@/components/Planning/Helpers/VControl";
import { EventBus } from "@/libraries/EventBus";
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import ProjectActionService from "@/services/ProjectActionService";
import VProjectActionTable from "./VProjectActionTable.vue";
import ProjectService from "@/services/ProjectService";

export default {
    props: {
        project_id: {},
        project_mom_id: {}
    },
    components: { VControl, VProjectActionCategoryForm, VProjectActionTable },
    data() {
        return {
            loading: true,
            showSection: true,
            showModalProjectActionCategory: false,
            categories: [],
            displayClosedActions: true,
            isPM: false,
            selectedFilter: "all"
        };
    },
    async created() {
        EventBus.$on("data-tab-open", () => {
            this.showSection = true;
        });
        EventBus.$on("data-tab-close", () => {
            this.showSection = false;
        });

        await this.fetchInfo();
        await this.fetchOverview();
        this.loading = false;
        // 12.01.26 MIS keep always open
        // await this.checkIfOpen();
    },
    beforeDestroy() {
        EventBus.$off("data-tab-open");
        EventBus.$off("data-tab-close");
    },
    methods: {
        async checkIfOpen() {
            try {
                const { data } = await ProjectActionService.GET_shouldOpen(
                    this.project_id,
                    1
                );
                if (data.data["should_open"] === true) {
                    this.showSection = true;
                }
            } catch (e) {
                console.log("E checkIfOpen", e);
            }
        },
        async fetchInfo() {
            try {
                const { data } = await ProjectService.GET_projectInterface(
                    this.project_id
                );
                this.isPM = data.data.requested_by_pm;
            } catch (e) {
                console.log("EX fi", e);
            }
        },
        async fetchOverview() {
            try {
                const params = { project_id: this.project_id };
                if (this.project_mom_id) {
                    params.project_mom_id = this.project_mom_id;
                } else {
                    params.context = "datatab";
                }
                const { data } = await ProjectActionCategoryService.GET(params);
                this.categories = data.data;
            } catch (e) {
                console.log("fo e", e);
            }
        },
        /**
         * Close modal and reload.
         */
        async projectActionCloseReload() {
            this.loading = true;
            await this.fetchOverview();
            this.loading = false;
        },
        async catCloseReload() {
            this.loading = true;
            await this.fetchOverview();
            this.loading = false;
            this.showModalProjectActionCategory = false;
        },
        openProjectActionCategory() {
            this.showModalProjectActionCategory = true;
        },
        /**
         * Filter
         * @param filterAction
         */
        filter(filterAction) {
            this.selectedFilter = filterAction;
        }
    }
};
</script>

<template>
    <div>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <div class="mb-3">
                        <v-control
                            :show="showSection"
                            @trigger="showSection = !showSection"
                        >
                            <h3 class="pb-0 mb-0">
                                {{ $t("project_actions.project_status") }}
                            </h3>
                        </v-control>
                    </div>
                    <template v-if="showSection">
                        <card body-classes="px-0">
                            <div
                                class="mx-4 mb-3 d-flex justify-content-between"
                            >
                                <div class="d-flex"></div>

                                <div>
                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'latestMonth'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('latestMonth')"
                                        >{{
                                            $t("pm_notes.filter_month")
                                        }}</base-button
                                    >
                                    <base-button
                                        size="sm"
                                        :type="
                                            selectedFilter == 'all'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        @click="filter('all')"
                                        >{{
                                            $t("pm_notes.filter_all")
                                        }}</base-button
                                    >
                                </div>

                                <div v-if="false">
                                    <base-button
                                        size="sm"
                                        type="secondary"
                                        @click="
                                            displayClosedActions = !displayClosedActions
                                        "
                                        >{{
                                            $t("project_actions.toggle_status")
                                        }}</base-button
                                    >
                                </div>
                            </div>

                            <template>
                                <v-loader :loading="loading" v-if="loading" />
                                <template v-else-if="categories.length > 0">
                                    <v-project-action-table
                                        v-for="(item, idx) in categories"
                                        :key="item.id"
                                        :project-id="project_id"
                                        :project-mom-id="project_mom_id"
                                        :category="item.name"
                                        :category-id="item.id"
                                        :filter="selectedFilter"
                                        :display-closed-actions="
                                            displayClosedActions
                                        "
                                        :is-first="idx === 0"
                                        :is-last="idx === categories.length - 1"
                                        :is-pm="isPM"
                                        @refresh-after-move="fetchOverview"
                                    />
                                </template>
                                <div
                                    class="mx-4 mt-4 alert alert-warning"
                                    v-else
                                >
                                    {{ $t("project_actions.no_items") }}
                                </div>
                            </template>
                            <base-button
                                type="link"
                                class="mt-3 mx-2"
                                @click="openProjectActionCategory"
                                ><i class="far fa-plus"></i
                                >{{
                                    $t("project_actions.add_category")
                                }}</base-button
                            >
                        </card>
                    </template>
                </div>
            </div>
        </div>
        <portal to="modals">
            <v-project-action-category-form
                v-if="showModalProjectActionCategory"
                @close="showModalProjectActionCategory = false"
                @close-reload="catCloseReload"
                :project-id="project_id"
                :project-mom-id="project_mom_id"
            />
        </portal>
    </div>
</template>
